import React from 'react';
import DefaultLayout from '../../../layouts/default';
// Import local sub-components from the components folder directory
import StaffTrainingHeader from './components/StaffTrainingHeader';
import SummaryDashboardRow from './components/SummaryDashboardRow';
import TrainingFormChecklist from './components/TrainingFormChecklist';

function MonthlyStaffTrainingCheckPage() {
  return (
    <DefaultLayout>
        <div className="w-full bg-slate-50/50 min-h-screen p-4 md:p-6 space-y-6 font-sans antialiased selection:bg-blue-500/10">
        
        {/* 1. Module Main Header & Navigation Control Row */}
        <section className="w-full">
            <StaffTrainingHeader />
        </section>

        {/* 2. Top-Level Metric Summary Cards Strip */}
        <section className="w-full">
            <SummaryDashboardRow />
        </section>

        {/* 3. Core Tabular Auditing Form Matrix Section */}
        <main className="w-full">
            <TrainingFormChecklist />
        </main>

        </div>
    </DefaultLayout>
  );
}

export default MonthlyStaffTrainingCheckPage;
